var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(!_vm.user)?_c('span',{staticClass:"resize-loading"},[_c('span',{staticClass:"loader"})]):_vm._e(),(_vm.user)?_c('user-form',{attrs:{"loading":_vm.loading,"userData":_vm.user,"formErrors":_vm.formErrors},on:{"userSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }